import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';
import { PayoutTransactionType } from 'services/payouts/types';

import { DataTableCellProps, TableCell } from 'components/dataTable';
import { CopyMenuItem, MenuItem } from 'components/dataTable/cells';
import { ActionMenu } from 'components/dataTable/cells/actionMenu';

import RoutePath from 'router/path';

import { LABELS } from '../../keys';
import { TransactionDataRow } from '../../types';

export const ActionsCell = ({ row }: DataTableCellProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { accountUuid } = useParams();

  const { source, orderUuid, type, payoutUuid } = row as TransactionDataRow;

  const menuBuilders = {
    [PayoutTransactionType.TRANSFER_FEE]: () => {
      if (payoutUuid === source) {
        return null;
      }

      return [<MenuItem onClick={navigateToPayout(source)}>{t(LABELS.ACTIONS.PAYOUT.OPEN_PAYOUT_DETAILS)}</MenuItem>];
    },
    [PayoutTransactionType.CHARGE]: () => [
      <CopyMenuItem value={source}>{t(LABELS.ACTIONS.PAYOUT.COPY_SOURCE_ID)}</CopyMenuItem>,
      <CopyMenuItem value={orderUuid}>{t(LABELS.ACTIONS.PAYOUT.COPY_ORDER_ID)}</CopyMenuItem>,
      <MenuItem onClick={navigateToOrder(orderUuid)}>{t(LABELS.ACTIONS.PAYOUT.OPEN_ORDER_DETAILS)}</MenuItem>,
    ],
  };

  const navigateToOrder = (uuid: string) => () => navigate(RoutePath.pwc.orderById(uuid));
  const navigateToPayout = (nextPayoutUuid: string) => () => {
    if (!accountUuid) {
      return;
    }
    navigate(RoutePath.pwc.payoutById(accountUuid, nextPayoutUuid));
  };

  const menuItems = menuBuilders[type]?.();

  if (!menuItems) {
    return <TableCell />;
  }

  return (
    <TableCell>
      <ActionMenu title={t(LABELS.ACTIONS.PAYOUT.TITLE)}>{menuItems}</ActionMenu>
    </TableCell>
  );
};
